import { render } from "./CsPage.vue?vue&type=template&id=8371efd4&scoped=true"
import script from "./CsPage.vue?vue&type=script&lang=js"
export * from "./CsPage.vue?vue&type=script&lang=js"

import "./CsPage.vue?vue&type=style&index=0&id=8371efd4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8371efd4"]])

export default __exports__